module.exports = __webpack_public_path__ + "img/td-1.3f4ae95e.jpg";